(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('supplierPerformanceSummary', supplierPerformanceSummary);

	supplierPerformanceSummary.$inject = ['$scope',  '$timeout', '$rootScope',  '$state','$filter', '$translate', '$location', '$experiments', 'siteUrl',
		'redirectParamsService', 'leanFilterService', 'tableRenderService', 'tableService', 'navigationService', 'supplierPerformanceSummaryService', 'storeService',
		'supplyChainReportColumns', 'drilldownFunctionsService', 'siteService', 'userAttributes'];

	function supplierPerformanceSummary($scope, $timeout, $rootScope, $state, $filter, $translate, $location, $experiments, siteUrl,
			redirectParamsService, leanFilterService, tableRenderService, tableService, navigationService,
			supplierPerformanceSummaryService, storeService, supplyChainReportColumns, drilldownFunctionsService, siteService, userAttributes) {
		var vm = this;
		var supplierCodeMap = null;
		var suppliers = [];
		var rendererParams = {
			'uomId': 'purchasingUOM',
			'multiFactory': true
		};
		var unsubscribe;
		var setFirstView = false;
		var isSupplier = globalConfig.user.role === 'Supplier';
		var adminSites = siteService.getAdminSitesByCustomer(globalConfig.customer.id).map(function(site) {return site.id;});
		var showUserManagementDrilldown = adminSites.length > 0;
		var canCreateSupplierUser = globalConfig.user.canCreateSupplierUser && !isSupplier;

		vm.firstTimeSlideIn = true;
		vm.SUPPLIER_COMPONENT = 'SUPPLIER_PERFORMANCE_SUMMARY';
		var reportSettingsName = 'performance-summary/last-month-performance';
		if ($state.current.name === 'app.supply-chain.performance-summary/rolling-average-performance') {
			reportSettingsName = 'performance-summary/rolling-average-performance';
		} else if ($state.current.name === 'app.supply-chain.performance.buckets') {
			reportSettingsName = 'SupplierPerformanceBuckets';
		}
		var pinnedColumns = [];
		var defaultFilters = [];
		var showWhitelistFilter = $experiments.isEnabled('workbench');
		var supplierRequestEnabled = $experiments.isEnabled('workbench');
		var useWorkbenchComplianceData = $experiments.isEnabled('useWorkbenchComplianceData');

		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		// Extra query params to send to backend in data requests
		var extraParams = [{
			excelReportName: 'SupplierPerformanceSummaryReport'
		}];
		if (useWorkbenchComplianceData) {
			extraParams.push({
				name: 'useWorkbenchComplianceData',
				value: useWorkbenchComplianceData
			});
		}
		// Extra drilldown query params to parse
		var extraFilters = [];

		$scope.filterService = leanFilterService;
		vm.reportName = 'Supplier performance summary (last month)';
		if ($state.current.name === 'app.supply-chain.performance-summary/rolling-average-performance') {
			vm.reportName = 'Supplier performance summary (rolling)';
		} else if ($state.current.name === 'app.supply-chain.performance.buckets') {
			vm.reportName = 'Monthly Performance';
		}

		vm.showExcel = true;

		// Extra query params to send to backend in data requests
		// Extra drilldown query params to parse
		extraFilters = [];

		function setupSupplierCodeToNdxMap() {
			if (supplierCodeMap == null || jQuery.isEmptyObject(supplierCodeMap)) {
				supplierCodeMap = {};
				suppliers.map(function(obj) {
					supplierCodeMap[obj['supplierCode']] = obj['supplierNdx'];
				});
			}
		}

		function supplierScorecardDrilldownRenderer(row, col, rowIndx, params) {
			var value = row[col.id];
			if (!value) {
				return '<div class="cell-div">Supplier Not Defined</div>';
			}

			var aTag = value;
			var ngClick = 'vm.openSupplierScoreCard(' + rowIndx + ');';
			if (!(row['supplierCode'] || row['supplierNdxs']) && row['supplierCodeInner']) {
				ngClick += '$event.stopPropagation();';
			}
			if (row['supplierNdxs'] || row['supplierCode'] || row['supplierCodeInner']) {
				aTag = '<a title="' + value + ': click to view detailed scorecard" ng-click="' + ngClick + '">' + value + '</a>';
			}

			return '<div class="cell-div cursor-pointer">' + aTag + '</div>';
		}

		var perfNaTitle = $translate.instant('Cannot show combined score for this row.  The sites combined on this row use different calculation methods for determining the delivery performance score.');
		function delPerfRenderer(row, col, rowIndx, params) {
			if (row.perfCompMethodCount > 1) {
				return '<div title="' + perfNaTitle + '" class="cell-div">N/A</div>';
			} else {
				return tableRenderService.perfRenderer(row, col, rowIndx, params);
			}
		}

		function daysLateRenderer(row, col, rowIndx, params) {
			var value = row[col.id] ? row[col.id] : '';
			var startDate = $state.current.name === 'app.supply-chain.performance-summary/last-month-performance'
				? new moment().subtract(1, 'months').date(1).valueOf()
				: new moment().subtract(12, 'months').date(1).valueOf();
			var endDate = $state.current.name === 'app.supply-chain.performance-summary/last-month-performance'
				? new moment().date(0).valueOf()
				: new moment().valueOf();
			var url;
			var filters = [{id: 'deliveryStatus', values: ['Delivered - Late']}, {id: 'supplierNdx', values: [row.supplierNdxs]}, {id: 'actualReceiptDate', comparator: 'Between', valueOne:  startDate, valueTwo: endDate}];
			url = 'home.html#/supply-chain/purchase-orders/' + drilldownFunctionsService.makeDrilldownParamString(filters, true, []);

			return '<div class="cell-div"><a target="_blank" href="' + url + '">' + value + '</a></div>';

		}

		var columns;
		var isRollingPerformance = false;
		var reportRenderers = {
			'supplierScorecardDrilldownRenderer': supplierScorecardDrilldownRenderer,
			'delPerfRenderer': delPerfRenderer,
			'daysLateRenderer': daysLateRenderer,
			'daysSinceLastAccessRenderer': daysSinceLastAccessRenderer
		};
		if ($state.current.name === 'app.supply-chain.performance.buckets') {
			columns = supplyChainReportColumns.getSupplierPerformanceBucketColumns(false, hideFromSuppliers(), reportRenderers);
			var month;
			for (var i = 1; i <= 12; i++) {
				month = moment().subtract(i, 'month').format('MMM YYYY');
				columns.push({
					'id': 'delPerfMonthBucket' + i,
					'display': 'Performance ' + month,
					'width': 100,
					'class': 'alignRight',
					'renderer': delPerfRenderer,
					'title': 'Percent of deliveries on time during period ' + i + ' month' + (i>1?'s':'') + ' ago.',
					'extraFormat': 'percentage'
				});
			}
		} else {
			if ($state.current.name === 'app.supply-chain.performance-summary/last-month-performance') {
				columns = supplyChainReportColumns.getSupplierPerformanceLastMonthColumns(false, hideFromSuppliers(), reportRenderers);
			} else if ($state.current.name === 'app.supply-chain.performance-summary/rolling-average-performance') {
				columns = supplyChainReportColumns.getSupplierPerformanceRollingAverageColumns(false, hideFromSuppliers(), reportRenderers);
				isRollingPerformance = true;
			}
		}

		var columnsForRequest = _.cloneDeep(columns.filter(function(col) { return !col.disabled;})).concat();

		init();
		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportUrl: '{0}/SupplierPerformanceSummaryReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: hideFromSuppliers() ? 'totalOnOrderInv': 'totalOnHandInv',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			recordsPerPage: 30,
			pageSize: 30,
			searchType: 'supplier',
			extraFilters: extraFilters,
			controllerModifiesColumns: true,
			setColumnDefaults: true,
			allColumnsNonBinding: true,
			hasMandatoryFilters: true,
			excelRequest: true,
			useReportBuilderForExcel: true,
			useExtraParamsForExcelWithReportBuilder: true,
			hideSearch: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {exportParams: {additionalParams: {'isRollingPerformance': isRollingPerformance, 'supplierRequestEnabled': supplierRequestEnabled}}, columns: columnsForRequest, doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined, showTotalRowCheckbox: leanFilterService.getFactoryList().split(',').length > 1, includeTotalRows: !!userAttributes.get('includeTotalRows')});
		}

		function getMeta() {
			return meta;
		}

		function daysSinceLastAccessRenderer(row, col, rowIndx, params) {
			if (!row['supplierName']) {
				return '<div class="cell-div"></div>';
			}

			var count = row.supplierAccessCount || 0,
				days = row.daysSinceLastAccess;
			var cellValue;
			var addUserLink = '(<a class="ldnaLink" title="{0}" ng-click="vm.addSupplierUser(' + rowIndx + ');">Add user</a>)';
			var notRegisteredLink =  'Not registered ' + String.format(addUserLink, 'Not registered: click to add user');
			var notRegistered = '<div class="cell-div">{0}</div>';
			var link  = '/application/f/home.html#/setup/manage-users?drilldown=1&supplierNdx={0}&site={1}';
			var url = '';
			var userHasAdminAccess = true;

			if (row['supplierNdxs'] && row['leanDirFactoryNdxs']) {
				url = String.format(link, row['supplierNdxs'], row['leanDirFactoryNdxs']);
				userHasAdminAccess = showUserManagementDrilldown && _.intersection(adminSites, row['leanDirFactoryNdxs'].split(',').map(Number)).length > 0;
			}

			if (count === 0) {
				return String.format(notRegistered, isSupplier ? '': userHasAdminAccess || canCreateSupplierUser ? notRegisteredLink: 'Not registered');
			} else {
				if (days === null || days === undefined) {
					cellValue = 'Never';
				} else if (days === 0) {
					cellValue = 'Today';
				} else if (days === 1) {
					cellValue = 'Yesterday';
				} else {
					cellValue = days + ' days ago';
				}
			}
			var hyperlink = isSupplier || !showUserManagementDrilldown ? cellValue: userHasAdminAccess ? String.format('<a href="{0}">{1}</a>', url, cellValue): cellValue;
			hyperlink = hyperlink + (userHasAdminAccess || canCreateSupplierUser ? String.format(addUserLink, 'Click to add user'): '');
			return '<div class="cell-div">' + hyperlink + '</div>';
		}

		function getData(params, extraParams) {
			var factoryNameCol = _.find(columns, {id: 'factoryName'})
				|| _.find(pinnedColumns, {id: 'factoryName'});
			if (factoryNameCol) {
				var factories = leanFilterService.getFactoryList() + ''; // as string
				factoryNameCol.disabled = factories.indexOf(',') === -1;
			}
			return tableService.postData(params, extraParams, columns).then(function (response) {
				if (!reportSettingsId && !setFirstView) {
					var firstViewObj = {
						'viewType': $state.current.data.viewType
					};
					navigationService.setFirstView(firstViewObj, reportSettingsName);
					setFirstView = true;
				}
				// If any data manipulation is needed, do it here
				translateMonthlyDeliveryScoreHeaders();
				updateTotals(response[1]);
				if (response[0] && response[0].data && response[0].data.length) {
					openSupplierScorecardFromDrilldown(response[0].data);
				}

				return response;
			});
		}

		function openSupplierScorecardFromDrilldown(data) {
			var params = $location.search();
			if (vm.firstTimeSlideIn && params['drilldown'] && params['drilldown'] === '1' && params['view'] &&
				params['view'] == 'scorecard') {
				var supplierCode = params['code'];
				var supplierNdx = params['supplierNdx'];
				var isRollup = params['isRollup'];
				var rowIndex = -1;
				var comparisonObj = {};
				if (isRollup && isRollup === '1') {
					comparisonObj['isRollup'] = 1;
					comparisonObj['supplierCodeInner'] = supplierCode;
				} else {
					comparisonObj['supplierNdxs'] = supplierNdx;
				}

				rowIndex = _.findIndex(data, comparisonObj);
				if (rowIndex >= 0) {
					$timeout(function() {
						$scope.$$childTail.vm.openSupplierScoreCard(rowIndex);
						vm.firstTimeSlideIn = false;
					}, 0);
				}
			}
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;

			defaultFilters = [{'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true}];
			if (!isSupplier) {
				defaultFilters.push({ 'id': 'supplierNdx', 'values': [$scope.filterService.leanDnaAllSelected], 'isMandatory': true});
			}
			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;

			var supplierFilter = $scope.filterService.filterDefinitions['Supplier'];
			supplierFilter.type = 'multiselect';
			supplierFilter.removable = false;

			if (isSupplier) {
				$scope.filterService.setMasterFilterList([
					siteFilter
				]);
			} else {
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['BusinessUnit'],
					$scope.filterService.filterDefinitions['Division'],
					$scope.filterService.filterDefinitions['Entity'],
					$scope.filterService.filterDefinitions['Global Supplier'],
					siteFilter,
					supplierFilter
				]);
				var singleSelectFilters = [$scope.filterService.filterDefinitions['showOnlyCriticalSuppliers']];
				if(showWhitelistFilter) {
					singleSelectFilters.push($scope.filterService.filterDefinitions['WhitelistedSuppliers']);
				}
				$scope.filterService.setMasterSingleSelectFilterList(singleSelectFilters);
			}
		}


		function renderTotal(row, col) {
			if (row[col.id] === undefined) {
				col.display = col.displayText || col.display;
				return;
			}
			var val;
			if (col.id.match(/^delPerf(rolling|month)/i)) {
				val = row[col.id] + '%';
			} else {
				val = row[col.id];
			}
			col.displayText = col.displayText || col.display;
			col.display = $translate.instant(col.displayText) + '<div style="text-align: right">' + val + '</div>';

		};

		function translateMonthlyDeliveryScoreHeaders() {
			var deliveryScore = $translate.instant('Delivery Score');
			(columns || []).forEach(function (col) {
				if (col.deliveryScoreMonthLabel) {
					col.display = deliveryScore + ' ' + col.deliveryScoreMonthLabel;
				}
			});
		}

		function updateTotals(totals) {
			if (totals) {
				var columns = meta.columns.concat(meta.pinnedColumns);
				columns.forEach(function(column) {
					renderTotal(totals, column);
				});
			}
		}

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		function hideFromSuppliers() {
			return globalConfig.user.role === 'Supplier';
		}
	}
})();
